import React from 'react';
import {
  Button,
} from '@material-ui/core';
import { Edit } from '@material-ui/icons';

import PropTypes from 'prop-types';

import translations from '../../languages/i18n';

import fieldStyles from '../../styles/fieldStyles';

export default function EditButton({ handleClick }) {
  const classes = fieldStyles();

  return (
    <Button
      className={classes.editButton}
      variant='contained'
      size='large'
      onClick={handleClick}
      startIcon={<Edit />}
    >
      {translations['_edit']}
    </Button>
  );
}

// Indica i controla els props que se han de passar al component
EditButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
};
